import React, { Component } from "react";
import clsx from 'clsx';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from "prop-types";
import {
    CssBaseline, CircularProgress, Container, Button, Grid, TextField, MenuItem,
    Stepper, Step, StepLabel, StepContent,
    Divider, Dialog, DialogTitle, DialogContent, DialogActions, Chip, IconButton
} from "@material-ui/core";
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CloseIcon from '@material-ui/icons/Close';
import { withStyles } from "@material-ui/core/styles";
import { Styles } from "../../styles/material-styles";
import { Overlay } from "../../styles/global";
import CustomizedSnackbars from "../../components/material-snackbars";
import HeaderMenu from "../../components/header-menu";
import Footer from '../../components/footer';
import { injectIntl } from 'react-intl';
import Card from '@material-ui/core/Card';
import SectionCard from '../../components/section-card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import { Link } from 'react-router-dom';
import WorkspaceValidator from '../../components/workspace-validator';
import * as componentActions from '../../redux/actions/admin-billing';
import * as adminBillingService from '../../services/admin-billing.service';
import * as adminProductService from '../../services/admin-product.service';
import Api from "../../services/api";

class AdminSubscriptionCreate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            openNotification: false,
            notificationVariant: "error",
            notificationMessage: "",
            activeStep: 0,
            item: { companyName: '', cnpj: '', responsibleName: '', responsiblePhone: '', email: '', workspace: '', companySizeId: '' },
            workspaceValid: false,
            companySizes: [],
            products: [],
            productsLoading: false,
            selectedProductIds: [],
            // Passo 3 - Plano POR PRODUTO. plansByProduct: { [appId]: [{id, name, isShared}] }
            // selectedPlansByProduct: { [appId]: planId }
            plansByProduct: {},
            plansLoading: false,
            selectedPlansByProduct: {},
            // Passo 4 - Periodicidade
            periodicities: {},
            periodicitiesLoading: false,
            selectedPeriodicities: {},
            // Passo 5 - Valores
            planDetails: {},
            planDetailsLoading: {},
            itemOverrides: {},
            // Passo 6 - Metodo de pagamento
            paymentGateways: [],
            paymentGatewaysLoading: false,
            selectedPaymentGatewayId: null,
            // Modal confirmacao
            confirmDialogOpen: false,
        };
        this.handleInputChange = this.handleInputChange.bind(this);
        this.closeNotification = this.closeNotification.bind(this);
    }

    componentDidMount() {
        // Plans são carregados PER produto (loadPlansForSelectedProducts) ao avançar do step 1.
        this.loadProducts();
        this.loadPaymentGateways();
        this.loadCompanySizes();
    }

    loadCompanySizes = () => {
        adminBillingService.getCompanySizes()
            .then(r => {
                const sizes = r.data.success ? (r.data.data || []) : [];
                this.setState({ companySizes: sizes });
            })
            .catch(() => {});
    }

    handleInputChange(e) {
        const { name, value } = e.target;
        this.setState(prevState => ({ item: { ...prevState.item, [name]: value } }));
    }
    handleWorkspaceChange = (value) => this.setState(prevState => ({ item: { ...prevState.item, workspace: value } }));
    handleWorkspaceValidation = (isValid) => this.setState({ workspaceValid: isValid });
    closeNotification() { this.setState({ openNotification: false }); }
    showError(msg) { this.setState({ openNotification: true, notificationVariant: 'error', notificationMessage: msg }); }

    // ========== Navigation ==========
    handleNext = () => {
        const intl = this.props.intl;
        const { activeStep } = this.state;
        if (activeStep === 0 && !this.validateStep1()) return;
        if (activeStep === 1 && this.state.selectedProductIds.length === 0) { this.showError(intl.formatMessage({ id: "admin.create.select.products" })); return; }
        // Step 3: agora plano-por-produto. Validar que TODO produto selecionado tem plano.
        if (activeStep === 2 && !this.validatePlansPerProduct()) return;
        if (activeStep === 3) {
            if (!this.validatePeriodicities()) return;
            this.loadPlanDetailsForSelected();
        }
        if (activeStep === 5 && !this.state.selectedPaymentGatewayId) { this.showError('Selecione um metodo de pagamento.'); return; }
        // Quando sai do step 1 (produtos selecionados), pré-carrega planos por produto pro step 3.
        if (activeStep === 1) { this.loadPlansForSelectedProducts(); }
        // Quando sai do step 2 (plano por produto), carrega periodicidades pra cada (appId, planId).
        if (activeStep === 2) { this.loadPeriodicitiesForPlan(); }
        this.setState(prevState => ({ activeStep: prevState.activeStep + 1 }));
    }

    validatePlansPerProduct() {
        const intl = this.props.intl;
        const { selectedProductIds, selectedPlansByProduct } = this.state;
        for (let pid of selectedProductIds) {
            if (!selectedPlansByProduct[pid]) { this.showError(intl.formatMessage({ id: "admin.create.select.plan" })); return false; }
        }
        return true;
    }
    handleBack = () => this.setState(prevState => ({ activeStep: prevState.activeStep - 1 }));

    validateStep1() {
        const intl = this.props.intl;
        const { item, workspaceValid } = this.state;
        if (!item.companyName || !item.email || !item.workspace || !item.responsibleName) { this.showError(intl.formatMessage({ id: "admin.trial.fill.required" })); return false; }
        if (!workspaceValid) { this.showError(intl.formatMessage({ id: "admin.trial.workspace.invalid" })); return false; }
        return true;
    }

    validatePeriodicities() {
        const intl = this.props.intl;
        const { selectedProductIds, selectedPeriodicities } = this.state;
        for (let pid of selectedProductIds) {
            if (!selectedPeriodicities[pid]) { this.showError(intl.formatMessage({ id: "admin.create.select.all.plans" })); return false; }
        }
        return true;
    }

    // ========== Data loading ==========
    loadProducts = () => {
        this.setState({ productsLoading: true });
        adminProductService.getProducts(true)
            .then(r => this.setState({ products: r.data.success ? (r.data.data || []) : [], productsLoading: false }))
            .catch(() => this.setState({ productsLoading: false }));
    }

    // Carrega os planos disponíveis POR PRODUTO selecionado (filtrados — só com periodicidade).
    // Chamado ao avançar do step 1 (produtos) pro step 2 (plano-por-produto).
    loadPlansForSelectedProducts = () => {
        const { selectedProductIds } = this.state;
        this.setState({ plansLoading: true });
        const promises = selectedProductIds.map(appId =>
            adminProductService.getPlansByApplication(appId, true)
                .then(r => ({ appId, data: r.data.success ? (r.data.data || []) : [] }))
                .catch(() => ({ appId, data: [] }))
        );
        Promise.all(promises).then(results => {
            const plansByProduct = {};
            results.forEach(r => { plansByProduct[r.appId] = r.data; });
            this.setState({ plansByProduct, plansLoading: false });
        });
    }

    // Carrega periodicidades por (productId, planId selecionado pra aquele produto).
    loadPeriodicitiesForPlan = () => {
        const { selectedProductIds, selectedPlansByProduct } = this.state;
        this.setState({ periodicitiesLoading: true });
        const promises = selectedProductIds.map(appId => {
            const planId = selectedPlansByProduct[appId];
            return adminProductService.getPlanPeriodicities(planId, appId)
                .then(r => ({ appId, data: r.data.success ? (r.data.data || []) : [] }))
                .catch(() => ({ appId, data: [] }));
        });
        Promise.all(promises).then(results => {
            const periodicities = {};
            results.forEach(r => { periodicities[r.appId] = r.data; });
            this.setState({ periodicities, periodicitiesLoading: false });
        });
    }

    // Helper: nome do plano selecionado pro produto (usado em step 4 e 6).
    getSelectedPlanName(appId) {
        const planId = this.state.selectedPlansByProduct[appId];
        if (!planId) return '-';
        const list = this.state.plansByProduct[appId] || [];
        return list.find(p => p.id === planId)?.name || '-';
    }

    loadPlanDetailsForSelected = () => {
        const { selectedProductIds, selectedPeriodicities } = this.state;
        selectedProductIds.forEach(appId => {
            const ppId = selectedPeriodicities[appId];
            if (!ppId || this.state.planDetails[appId]) return;
            this.setState(prev => ({ planDetailsLoading: { ...prev.planDetailsLoading, [appId]: true } }));
            adminProductService.getPlanPeriodicityDetail(ppId)
                .then(r => {
                    if (r.data.success) {
                        const rawData = r.data.data;
                        const d = rawData?.detail ?? rawData;
                        this.setState(prev => ({
                            planDetails: { ...prev.planDetails, [appId]: d },
                            planDetailsLoading: { ...prev.planDetailsLoading, [appId]: false },
                            itemOverrides: { ...prev.itemOverrides, [appId]: {
                                // Valor unitario de tabela: prioriza unit_value do plan_periodicity,
                                // depois base_value do produto (catalogo), depois plan_value_per_month
                                // (compat com planos antigos sem backfill).
                                unitValue: d.unitvalue ?? d.unitValue ?? d.basevalue ?? d.baseValue ?? d.planvaluepermonth ?? d.planValuePerMonth ?? 0,
                                planValuePerMonth: d.planvaluepermonth ?? d.planValuePerMonth ?? 0,
                                planValue: d.planvalue ?? 0,
                                agentLimitQuantity: d.agentlimitquantity ?? 0,
                                diskLimitUsage: d.disklimitusage ?? 0,
                                attendanceLimitPerMonth: d.attendancelimitpermonth ?? 0,
                                additionalValueAgent: d.additionalvalueagent ?? 0,
                                attendanceValue: d.attendancevalue ?? 0,
                                diskOverageValue: d.diskoveragevalue ?? 0,
                                billingMode: d.billingmode ?? 'unit',
                                creditAmountMonthly: d.creditamountmonthly ?? 0,
                                creditAlertThreshold: d.creditalertthreshold ?? 0,
                                creditAutoRechargeEnabled: d.creditautorechargeenabled ?? d.creditautorechchargeenabled ?? false,
                                creditAutoRechargeAmount: d.creditautorechargeamount ?? 0,
                                creditAutoRechargeTrigger: d.creditautorechargetrigger ?? 0,
                                quantity: d.quantity ?? 1,
                            }},
                        }));
                    } else { this.setState(prev => ({ planDetailsLoading: { ...prev.planDetailsLoading, [appId]: false } })); }
                })
                .catch(() => this.setState(prev => ({ planDetailsLoading: { ...prev.planDetailsLoading, [appId]: false } })));
        });
    }

    loadPaymentGateways = () => {
        this.setState({ paymentGatewaysLoading: true });
        adminBillingService.getPaymentGateways()
            .then(r => {
                const gateways = r.data.success ? (r.data.data || []) : [];
                this.setState({ paymentGateways: gateways, paymentGatewaysLoading: false,
                    selectedPaymentGatewayId: gateways.length > 0 ? (gateways.find(g => g.isdefault || g.isDefault)?.id || gateways[0].id) : null });
            })
            .catch(() => this.setState({ paymentGatewaysLoading: false }));
    }

    handleToggleProduct = (id) => {
        this.setState(prev => {
            const s = [...prev.selectedProductIds];
            const i = s.indexOf(id);
            i > -1 ? s.splice(i, 1) : s.push(id);
            return { selectedProductIds: s };
        });
    }
    handleOverrideChange = (appId, field, value) => {
        this.setState(prev => ({
            itemOverrides: { ...prev.itemOverrides, [appId]: { ...prev.itemOverrides[appId], [field]: value === '' ? '' : (field === 'billingMode' || field === 'creditAutoRechargeEnabled' ? value : Number(value)) } }
        }));
    }

    // ========== Submit ==========
    handleSubmit = () => { this.setState({ confirmDialogOpen: true }); }

    handleConfirmCreate = () => {
        const intl = this.props.intl;
        const { item, selectedProductIds, selectedPeriodicities, itemOverrides } = this.state;
        this.setState({ confirmDialogOpen: false, loading: true });

        const selectedItems = selectedProductIds.map(appId => ({ applicationId: appId, planPeriodicityId: selectedPeriodicities[appId], ...(itemOverrides[appId] || {}) }));

        const payload = {
            companyName: item.companyName, responsibleName: item.responsibleName, responsibleEmail: item.email, responsiblePhone: item.responsiblePhone,
            workspace: item.workspace, cnpj: item.cnpj, trialDurationDays: 0, contractType: 'dedicated',
            planPeriodicityId: selectedItems[0]?.planPeriodicityId,
            paymentGatewayId: this.state.selectedPaymentGatewayId,
            companySizeId: item.companySizeId ? parseInt(item.companySizeId) : null,
            items: selectedItems.map(si => ({
                applicationId: si.applicationId, planPeriodicityId: si.planPeriodicityId,
                unitValue: si.unitValue,
                planValuePerMonth: si.planValuePerMonth, agentLimitQuantity: si.agentLimitQuantity,
                diskLimitUsage: si.diskLimitUsage, attendanceLimitPerMonth: si.attendanceLimitPerMonth,
                additionalValueAgent: si.additionalValueAgent,
                attendanceValue: si.attendanceValue, diskOverageValue: si.diskOverageValue,
                billingMode: si.billingMode, quantity: si.quantity,
                creditAmountMonthly: si.creditAmountMonthly, creditAlertThreshold: si.creditAlertThreshold,
                creditAutoRechargeEnabled: si.creditAutoRechargeEnabled,
                creditAutoRechargeAmount: si.creditAutoRechargeAmount, creditAutoRechargeTrigger: si.creditAutoRechargeTrigger,
            })),
        };

        adminBillingService.createContract(payload)
            .then(result => {
                if (result.data.success) {
                    this.setState({ loading: false, openNotification: true, notificationVariant: 'success', notificationMessage: intl.formatMessage({ id: "add.success" }) });
                    const responseData = result.data.data;
                    const queueId = responseData?.provisioningqueueid ?? responseData?.provisioningQueueId;
                    if (queueId) {
                        // Redirecionar pro detalhe do provisionamento pra acompanhar
                        this.props.addCurrentProvisioning({ id: queueId, workspace: item.workspace });
                        setTimeout(() => this.props.history.push(`/${this.props.match.params.lang}/admin-provisioning-detail`), 1500);
                    } else {
                        setTimeout(() => this.props.history.push(`/${this.props.match.params.lang}/admin-provisioning`), 1500);
                    }
                } else { this.setState({ loading: false, openNotification: true, notificationVariant: 'error', notificationMessage: result.data.errors?.[0] || intl.formatMessage({ id: "process.error" }) }); }
            })
            .catch(err => { this.setState({ loading: false, openNotification: true, notificationVariant: 'error', notificationMessage: err.response?.data?.errors?.[0] || intl.formatMessage({ id: "process.error" }) }); Api.kickoff(err); });
    }

    // ========== Helpers ==========
    getProductName(id) { return this.state.products.find(p => p.id === id)?.name || `Produto #${id}`; }
    getPeriodicityLabel(appId) {
        const ppId = this.state.selectedPeriodicities[appId];
        const list = this.state.periodicities[appId] || [];
        const pp = list.find(p => p.id === ppId);
        return pp ? `${pp.periodicityname ?? pp.periodicityName} - R$ ${(pp.planvaluepermonth ?? pp.planValuePerMonth ?? pp.value) ? Number(pp.planvaluepermonth ?? pp.planValuePerMonth ?? pp.value ?? 0).toFixed(2) : '0.00'}` : '-';
    }
    // Variante sem o valor anexado — usado no resumo (renderStep6) onde a coluna "Valor/Mes"
    // já mostra o valor unitário; ter outro valor ao lado da periodicidade era redundante e
    // causava confusão (parecia ser o total).
    getPeriodicityName(appId) {
        const ppId = this.state.selectedPeriodicities[appId];
        const list = this.state.periodicities[appId] || [];
        const pp = list.find(p => p.id === ppId);
        return pp ? (pp.periodicityname ?? pp.periodicityName ?? '-') : '-';
    }
    getTotal() {
        let t = 0;
        this.state.selectedProductIds.forEach(id => {
            const o = this.state.itemOverrides[id];
            if (!o) return;
            const valor = Number(o.planValuePerMonth) || 0;
            const qtd = Number(o.quantity) || 1;
            t += valor * qtd;
        });
        return t;
    }

    // ========== Step Renderers ==========
    renderStep1() {
        const intl = this.props.intl;
        const { item } = this.state;
        return (
            <Grid container spacing={2}>
                <Grid item xs={12} sm={6}><TextField label={intl.formatMessage({ id: "admin.trial.company.name" })} name="companyName" value={item.companyName} onChange={this.handleInputChange} fullWidth required /></Grid>
                <Grid item xs={12} sm={6}><TextField label="CNPJ" name="cnpj" value={item.cnpj} onChange={this.handleInputChange} fullWidth /></Grid>
                <Grid item xs={12} sm={6}><TextField label={intl.formatMessage({ id: "admin.trial.responsible.name" })} name="responsibleName" value={item.responsibleName} onChange={this.handleInputChange} fullWidth required /></Grid>
                <Grid item xs={12} sm={6}><TextField label="E-mail Responsavel" name="email" type="email" value={item.email} onChange={this.handleInputChange} fullWidth required /></Grid>
                <Grid item xs={12} sm={6}><TextField label="Telefone do Responsavel" name="responsiblePhone" value={item.responsiblePhone} onChange={this.handleInputChange} fullWidth /></Grid>
                <Grid item xs={12} sm={6}>
                    <TextField
                        label={intl.formatMessage({ id: "admin.hirer.company_size" })}
                        name="companySizeId"
                        select
                        SelectProps={{ native: true }}
                        InputLabelProps={{ shrink: true }}
                        value={item.companySizeId}
                        onChange={this.handleInputChange}
                        fullWidth
                    >
                        <option value="">{intl.formatMessage({ id: "admin.hirer.company_size.placeholder" })}</option>
                        {this.state.companySizes.map(cs => (
                            <option key={cs.id} value={cs.id}>{cs.name}</option>
                        ))}
                    </TextField>
                </Grid>
                <Grid item xs={12} sm={6}><WorkspaceValidator label={intl.formatMessage({ id: "admin.trial.workspace" })} value={item.workspace} onChange={this.handleWorkspaceChange} onValidation={this.handleWorkspaceValidation} required /></Grid>
            </Grid>
        );
    }

    renderStep2() {
        const { products, productsLoading, selectedProductIds } = this.state;
        if (productsLoading) return <CircularProgress size={24} />;
        return (
            <Grid container spacing={2}>
                {products.map(p => {
                    const selected = selectedProductIds.includes(p.id);
                    return (
                        <Grid item xs={12} sm={6} md={4} key={p.id}>
                            <Card onClick={() => this.handleToggleProduct(p.id)} style={{
                                cursor: 'pointer', borderRadius: 12, border: selected ? '2px solid #8BC34A' : '1px solid #e0e0e0',
                                backgroundColor: selected ? '#f1f8e9' : '#fff', transition: 'all 0.2s', position: 'relative'
                            }}>
                                <CardContent style={{ textAlign: 'center', padding: '24px 16px' }}>
                                    {selected && <CheckCircleIcon style={{ position: 'absolute', top: 8, right: 8, color: '#8BC34A', fontSize: 24 }} />}
                                    <Typography variant="h6" style={{ fontWeight: 600, color: selected ? '#33691e' : '#424242' }}>{p.name}</Typography>
                                    <Typography variant="caption" color="textSecondary">ID: {p.id}</Typography>
                                    {p.description && <Typography variant="body2" color="textSecondary" style={{ marginTop: 8 }}>{p.description}</Typography>}
                                </CardContent>
                            </Card>
                        </Grid>
                    );
                })}
            </Grid>
        );
    }

    renderStep3() {
        // Plano POR PRODUTO. Loop semelhante ao step 4 (periodicidade).
        const { selectedProductIds, plansByProduct, plansLoading, selectedPlansByProduct } = this.state;
        if (plansLoading) return <CircularProgress size={24} />;
        return (
            <Grid container spacing={3}>
                {selectedProductIds.map(appId => {
                    const plans = (plansByProduct[appId] || []).filter(p => !p.isShared);
                    const selectedPlanId = selectedPlansByProduct[appId];
                    return (
                        <Grid item xs={12} key={appId}>
                            <Typography variant="subtitle1" style={{ fontWeight: 600, marginBottom: 8 }}>{this.getProductName(appId)}</Typography>
                            {plans.length === 0 ? (
                                <Typography variant="body2" color="textSecondary" style={{ fontStyle: 'italic', padding: 12 }}>
                                    Nenhum plano dedicado disponível para este produto.
                                </Typography>
                            ) : (
                                <Grid container spacing={2}>
                                    {plans.map(plan => {
                                        const sel = selectedPlanId === plan.id;
                                        return (
                                            <Grid item xs={12} sm={6} md={4} key={plan.id}>
                                                <Card onClick={() => this.setState(prev => ({
                                                    selectedPlansByProduct: { ...prev.selectedPlansByProduct, [appId]: plan.id },
                                                    // Limpa periodicidade/detalhes do produto ao trocar de plano (evita estado inconsistente).
                                                    selectedPeriodicities: { ...prev.selectedPeriodicities, [appId]: undefined },
                                                    planDetails: { ...prev.planDetails, [appId]: undefined },
                                                    itemOverrides: { ...prev.itemOverrides, [appId]: undefined },
                                                }))} style={{
                                                    cursor: 'pointer', borderRadius: 12, border: sel ? '2px solid #277afe' : '1px solid #e0e0e0',
                                                    backgroundColor: sel ? '#e3f2fd' : '#fff', transition: 'all 0.2s', position: 'relative'
                                                }}>
                                                    <CardContent style={{ textAlign: 'center', padding: '24px 16px' }}>
                                                        {sel && <CheckCircleIcon style={{ position: 'absolute', top: 8, right: 8, color: '#277afe', fontSize: 24 }} />}
                                                        <Typography variant="h6" style={{ fontWeight: 600, color: sel ? '#0d47a1' : '#424242' }}>{plan.name}</Typography>
                                                        <Chip label={plan.isShared ? 'Compartilhado' : 'Dedicado'} size="small" style={{ marginTop: 8, backgroundColor: plan.isShared ? '#e0e0e0' : '#bbdefb' }} />
                                                    </CardContent>
                                                </Card>
                                            </Grid>
                                        );
                                    })}
                                </Grid>
                            )}
                            <Divider style={{ marginTop: 16 }} />
                        </Grid>
                    );
                })}
            </Grid>
        );
    }

    renderStep4() {
        const intl = this.props.intl;
        const { selectedProductIds, periodicities, periodicitiesLoading, selectedPeriodicities } = this.state;
        if (periodicitiesLoading) return <CircularProgress size={24} />;
        return (
            <Grid container spacing={3}>
                {selectedProductIds.map(appId => {
                    const ppList = periodicities[appId] || [];
                    const selectedValue = selectedPeriodicities[appId] || '';
                    const planName = this.getSelectedPlanName(appId);
                    return (
                        <Grid item xs={12} key={appId}>
                            <Typography variant="subtitle1" style={{ fontWeight: 600, marginBottom: 8 }}>{this.getProductName(appId)} - {planName}</Typography>
                            <Grid container spacing={2}>
                                {ppList.map(pp => {
                                    const sel = selectedValue == pp.id;
                                    return (
                                        <Grid item xs={12} sm={6} md={4} key={pp.id}>
                                            <Card onClick={() => this.setState(prev => ({
                                                selectedPeriodicities: { ...prev.selectedPeriodicities, [appId]: pp.id },
                                                planDetails: { ...prev.planDetails, [appId]: undefined },
                                                itemOverrides: { ...prev.itemOverrides, [appId]: undefined },
                                            }))} style={{
                                                cursor: 'pointer', borderRadius: 12, border: sel ? '2px solid #ff9800' : '1px solid #e0e0e0',
                                                backgroundColor: sel ? '#fff3e0' : '#fff', transition: 'all 0.2s', position: 'relative'
                                            }}>
                                                <CardContent style={{ textAlign: 'center', padding: '16px' }}>
                                                    {sel && <CheckCircleIcon style={{ position: 'absolute', top: 8, right: 8, color: '#ff9800', fontSize: 20 }} />}
                                                    <Typography variant="body1" style={{ fontWeight: 500 }}>{pp.periodicityname ?? pp.periodicityName}</Typography>
                                                    <Typography variant="h6" style={{ color: '#ff9800', fontWeight: 700, marginTop: 4 }}>R$ {(pp.planvaluepermonth ?? pp.planValuePerMonth ?? pp.value) ? Number(pp.planvaluepermonth ?? pp.planValuePerMonth ?? pp.value ?? 0).toFixed(2) : '0.00'}</Typography>
                                                </CardContent>
                                            </Card>
                                        </Grid>
                                    );
                                })}
                            </Grid>
                            <Divider style={{ marginTop: 16 }} />
                        </Grid>
                    );
                })}
            </Grid>
        );
    }

    renderStep5() {
        const intl = this.props.intl;
        const { selectedProductIds, planDetailsLoading, itemOverrides } = this.state;
        return (
            <Grid container spacing={3}>
                {selectedProductIds.map(appId => {
                    const isLoading = planDetailsLoading[appId];
                    const ov = itemOverrides[appId] || {};
                    return (
                        <Grid item xs={12} key={appId}>
                            <Card variant="outlined" style={{ borderRadius: 12, padding: 8 }}>
                                <CardContent>
                                    <Typography variant="subtitle1" style={{ fontWeight: 600, marginBottom: 12 }}>{this.getProductName(appId)} - {this.getSelectedPlanName(appId)} - {this.getPeriodicityLabel(appId)}</Typography>
                                    {isLoading ? <CircularProgress size={20} /> : (
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} sm={4}>
                                                <TextField
                                                    label="Valor Unitario Mensal de Tabela (R$)"
                                                    type="number"
                                                    value={ov.unitValue ?? ''}
                                                    onChange={e => this.handleOverrideChange(appId, 'unitValue', e.target.value)}
                                                    fullWidth
                                                    inputProps={{ step: "0.01", min: "0" }}
                                                    helperText="Preco de catalogo (referencia)"
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={4}>
                                                <TextField
                                                    label="Valor Mensal Negociado (R$)"
                                                    type="number"
                                                    value={ov.planValuePerMonth ?? ''}
                                                    onChange={e => this.handleOverrideChange(appId, 'planValuePerMonth', e.target.value)}
                                                    fullWidth
                                                    inputProps={{ step: "0.01", min: "0" }}
                                                    helperText="Igual ao unitario, ou com desconto"
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={4}><TextField label="Limite de Agentes" type="number" value={ov.agentLimitQuantity ?? ''} onChange={e => this.handleOverrideChange(appId, 'agentLimitQuantity', e.target.value)} fullWidth /></Grid>
                                            <Grid item xs={12} sm={4}><TextField label="Limite de Disco (MB)" type="number" value={ov.diskLimitUsage ?? ''} onChange={e => this.handleOverrideChange(appId, 'diskLimitUsage', e.target.value)} fullWidth /></Grid>
                                            <Grid item xs={12} sm={4}><TextField label="Atendimentos/Mes" type="number" value={ov.attendanceLimitPerMonth ?? ''} onChange={e => this.handleOverrideChange(appId, 'attendanceLimitPerMonth', e.target.value)} fullWidth /></Grid>
                                            <Grid item xs={12} sm={4}><TextField label="Valor Agente Adicional (R$)" type="number" value={ov.additionalValueAgent ?? ''} onChange={e => this.handleOverrideChange(appId, 'additionalValueAgent', e.target.value)} fullWidth inputProps={{ step: "0.01" }} /></Grid>
                                            <Grid item xs={12} sm={4}><TextField label="Valor Atendimento (R$)" type="number" value={ov.attendanceValue ?? ''} onChange={e => this.handleOverrideChange(appId, 'attendanceValue', e.target.value)} fullWidth inputProps={{ step: "0.0001" }} /></Grid>
                                            <Grid item xs={12} sm={4}><TextField label="Valor Disco Excedente (R$)" type="number" value={ov.diskOverageValue ?? ''} onChange={e => this.handleOverrideChange(appId, 'diskOverageValue', e.target.value)} fullWidth inputProps={{ step: "0.0001" }} /></Grid>
                                            <Grid item xs={12} sm={4}>
                                                {(() => {
                                                    const product = this.state.products.find(p => p.id === appId);
                                                    const rawModes = product?.allowedbillingmodes ?? product?.allowedBillingModes;
                                                    const billingModeMap = { 1: 'unit', 2: 'credit' };
                                                    const allowedModes = Array.isArray(rawModes)
                                                        ? rawModes.map(m => billingModeMap[m] || String(m))
                                                        : typeof rawModes === 'string'
                                                            ? rawModes.split(',').map(m => m.trim())
                                                            : ['unit', 'credit'];
                                                    return (
                                                        <TextField label={intl.formatMessage({ id: "admin.pp.billing.mode" })} select value={ov.billingMode ?? 'unit'} onChange={e => this.handleOverrideChange(appId, 'billingMode', e.target.value)} fullWidth SelectProps={{ native: true }} InputLabelProps={{ shrink: true }}>
                                                            {allowedModes.includes('unit') && <option value="unit">Unitario</option>}
                                                            {allowedModes.includes('credit') && <option value="credit">Credito</option>}
                                                        </TextField>
                                                    );
                                                })()}
                                            </Grid>
                                            <Grid item xs={12} sm={4}><TextField label="Quantidade" type="number" value={ov.quantity ?? 1} onChange={e => this.handleOverrideChange(appId, 'quantity', e.target.value)} fullWidth /></Grid>
                                            {ov.billingMode === 'credit' && (<>
                                                <Grid item xs={12}><Divider /><Typography variant="body2" color="textSecondary" style={{ marginTop: 8, fontWeight: 500 }}>{intl.formatMessage({ id: "admin.pp.credit.section" })}</Typography></Grid>
                                                <Grid item xs={12} sm={4}><TextField label={intl.formatMessage({ id: "admin.pp.credit.monthly" })} type="number" value={ov.creditAmountMonthly ?? ''} onChange={e => this.handleOverrideChange(appId, 'creditAmountMonthly', e.target.value)} fullWidth inputProps={{ step: "0.01" }} /></Grid>
                                                <Grid item xs={12} sm={4}><TextField label={intl.formatMessage({ id: "admin.pp.credit.alert" })} type="number" value={ov.creditAlertThreshold ?? ''} onChange={e => this.handleOverrideChange(appId, 'creditAlertThreshold', e.target.value)} fullWidth inputProps={{ step: "0.01" }} /></Grid>
                                                <Grid item xs={12} sm={4}>
                                                    <TextField label={intl.formatMessage({ id: "admin.pp.credit.auto.recharge" })} select value={ov.creditAutoRechargeEnabled ? 'true' : 'false'} onChange={e => this.handleOverrideChange(appId, 'creditAutoRechargeEnabled', e.target.value === 'true')} fullWidth SelectProps={{ native: true }} InputLabelProps={{ shrink: true }}>
                                                        <option value="false">Nao</option>
                                                        <option value="true">Sim</option>
                                                    </TextField>
                                                </Grid>
                                                {ov.creditAutoRechargeEnabled && (<>
                                                    <Grid item xs={12} sm={4}><TextField label={intl.formatMessage({ id: "admin.pp.credit.recharge.amount" })} type="number" value={ov.creditAutoRechargeAmount ?? ''} onChange={e => this.handleOverrideChange(appId, 'creditAutoRechargeAmount', e.target.value)} fullWidth inputProps={{ step: "0.01" }} /></Grid>
                                                    <Grid item xs={12} sm={4}><TextField label={intl.formatMessage({ id: "admin.pp.credit.recharge.trigger" })} type="number" value={ov.creditAutoRechargeTrigger ?? ''} onChange={e => this.handleOverrideChange(appId, 'creditAutoRechargeTrigger', e.target.value)} fullWidth inputProps={{ step: "0.01" }} /></Grid>
                                                </>)}
                                            </>)}
                                        </Grid>
                                    )}
                                </CardContent>
                            </Card>
                        </Grid>
                    );
                })}
                <Grid item xs={12}><Typography variant="h6" style={{ textAlign: 'right' }}>{intl.formatMessage({ id: "admin.create.total" })}: R$ {this.getTotal().toFixed(2)}</Typography></Grid>
            </Grid>
        );
    }

    renderStep6() {
        const intl = this.props.intl;
        const { item, selectedProductIds, itemOverrides, paymentGateways, selectedPaymentGatewayId } = this.state;
        const selectedGateway = paymentGateways.find(g => (g.id ?? g.Id) === selectedPaymentGatewayId);
        const gwType = selectedGateway ? (selectedGateway.gatewaytype ?? selectedGateway.gatewayType ?? selectedGateway.gateway_type ?? '') : '';
        const gwName = selectedGateway ? (selectedGateway.name ?? selectedGateway.Name ?? gwType) : '-';
        return (
            <div>
                <Typography variant="h6" style={{ marginBottom: 12 }}>{intl.formatMessage({ id: "admin.create.step.data" })}</Typography>
                <Grid container spacing={2} style={{ marginBottom: 16 }}>
                    <Grid item xs={12} sm={6}>
                        <Typography variant="body2" color="textSecondary">{intl.formatMessage({ id: "admin.trial.company.name" })}</Typography>
                        <Typography variant="body1">{item.companyName}</Typography>
                    </Grid>
                    {item.cnpj && <Grid item xs={12} sm={6}>
                        <Typography variant="body2" color="textSecondary">CNPJ</Typography>
                        <Typography variant="body1">{item.cnpj}</Typography>
                    </Grid>}
                    <Grid item xs={12} sm={6}>
                        <Typography variant="body2" color="textSecondary">{intl.formatMessage({ id: "admin.trial.responsible.name" })}</Typography>
                        <Typography variant="body1">{item.responsibleName}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Typography variant="body2" color="textSecondary">{intl.formatMessage({ id: "email" })}</Typography>
                        <Typography variant="body1">{item.email}</Typography>
                    </Grid>
                    {item.responsiblePhone && <Grid item xs={12} sm={6}>
                        <Typography variant="body2" color="textSecondary">Telefone do Responsavel</Typography>
                        <Typography variant="body1">{item.responsiblePhone}</Typography>
                    </Grid>}
                    <Grid item xs={12} sm={6}>
                        <Typography variant="body2" color="textSecondary">Workspace</Typography>
                        <Typography variant="body1">{item.workspace}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Typography variant="body2" color="textSecondary">Tipo de Contrato</Typography>
                        <Typography variant="body1">Dedicado</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Typography variant="body2" color="textSecondary">Metodo de Pagamento</Typography>
                        <Typography variant="body1">{gwName}{gwType ? ` (${gwType === 'manual' ? 'Faturamento Manual' : 'Gateway Online'})` : ''}</Typography>
                    </Grid>
                </Grid>
                <Divider style={{ marginBottom: 16 }} />
                <Typography variant="h6" style={{ marginBottom: 12 }}>{intl.formatMessage({ id: "admin.create.step.products" })}</Typography>
                {selectedProductIds.map(appId => {
                    const ov = itemOverrides[appId] || {};
                    return (
                        <Card variant="outlined" key={appId} style={{ marginBottom: 12, padding: 12, borderRadius: 8 }}>
                            <Typography variant="subtitle1" style={{ fontWeight: 600, marginBottom: 8 }}>{this.getProductName(appId)} - {this.getSelectedPlanName(appId)} - {this.getPeriodicityName(appId)}</Typography>
                            <Grid container spacing={1}>
                                <Grid item xs={6} sm={3}><Typography variant="body2">Unit. Tabela: R$ {Number(ov.unitValue || 0).toFixed(2)}</Typography></Grid>
                                <Grid item xs={6} sm={3}><Typography variant="body2">Valor/Mes Negoc.: R$ {Number(ov.planValuePerMonth || 0).toFixed(2)}</Typography></Grid>
                                <Grid item xs={6} sm={3}><Typography variant="body2">Agentes: {ov.agentLimitQuantity || 0}</Typography></Grid>
                                <Grid item xs={6} sm={3}><Typography variant="body2">Disco: {ov.diskLimitUsage || 0} MB</Typography></Grid>
                                <Grid item xs={6} sm={3}><Typography variant="body2">Atend./Mes: {ov.attendanceLimitPerMonth || 0}</Typography></Grid>
                                <Grid item xs={6} sm={3}><Typography variant="body2">Agente Adic.: R$ {Number(ov.additionalValueAgent || 0).toFixed(2)}</Typography></Grid>
                                <Grid item xs={6} sm={3}><Typography variant="body2">Valor Atend.: R$ {Number(ov.attendanceValue || 0).toFixed(4)}</Typography></Grid>
                                <Grid item xs={6} sm={3}><Typography variant="body2">Disco Exced.: R$ {Number(ov.diskOverageValue || 0).toFixed(4)}</Typography></Grid>
                                <Grid item xs={6} sm={3}><Typography variant="body2">Modo: {ov.billingMode === 'credit' ? 'Credito' : 'Unitario'}</Typography></Grid>
                                <Grid item xs={6} sm={3}><Typography variant="body2">Qtd: {ov.quantity || 1}</Typography></Grid>
                                {ov.billingMode === 'credit' && <>
                                    <Grid item xs={6} sm={3}><Typography variant="body2">Credito Mensal: R$ {Number(ov.creditAmountMonthly || 0).toFixed(2)}</Typography></Grid>
                                    <Grid item xs={6} sm={3}><Typography variant="body2">Alerta Credito: R$ {Number(ov.creditAlertThreshold || 0).toFixed(2)}</Typography></Grid>
                                    <Grid item xs={6} sm={3}><Typography variant="body2">Recarga Auto: {ov.creditAutoRechargeEnabled ? 'Sim' : 'Nao'}</Typography></Grid>
                                    {ov.creditAutoRechargeEnabled && <>
                                        <Grid item xs={6} sm={3}><Typography variant="body2">Valor Recarga: R$ {Number(ov.creditAutoRechargeAmount || 0).toFixed(2)}</Typography></Grid>
                                        <Grid item xs={6} sm={3}><Typography variant="body2">Gatilho Recarga: R$ {Number(ov.creditAutoRechargeTrigger || 0).toFixed(2)}</Typography></Grid>
                                    </>}
                                </>}
                            </Grid>
                        </Card>
                    );
                })}
                <Divider style={{ marginTop: 8, marginBottom: 12 }} />
                <Typography variant="h6" style={{ textAlign: 'right' }}>{intl.formatMessage({ id: "admin.create.total" })}: R$ {this.getTotal().toFixed(2)}</Typography>
            </div>
        );
    }

    getStepLabels() {
        const intl = this.props.intl;
        return [
            intl.formatMessage({ id: "admin.create.step.data" }),
            intl.formatMessage({ id: "admin.create.step.products" }),
            'Selecionar Plano',
            'Selecionar Periodicidade',
            intl.formatMessage({ id: "admin.create.step.limits" }),
            'Metodo de Pagamento',
            intl.formatMessage({ id: "admin.create.step.review" }),
        ];
    }

    getStepContent(step) {
        switch (step) {
            case 0: return this.renderStep1();
            case 1: return this.renderStep2();
            case 2: return this.renderStep3();
            case 3: return this.renderStep4();
            case 4: return this.renderStep5();
            case 5: return this.renderStepPaymentGateway();
            case 6: return this.renderStep6();
            default: return null;
        }
    }

    renderStepPaymentGateway() {
        const { paymentGateways, paymentGatewaysLoading, selectedPaymentGatewayId } = this.state;
        if (paymentGatewaysLoading) return <CircularProgress size={24} />;
        return (
            <div>
                <Typography variant="subtitle1" style={{ fontWeight: 600, marginBottom: 12 }}>Selecione o metodo de pagamento do contrato:</Typography>
                <Grid container spacing={2}>
                    {paymentGateways.map(gw => {
                        const gwId = gw.id ?? gw.Id;
                        const sel = selectedPaymentGatewayId === gwId;
                        const gwType = gw.gatewaytype ?? gw.gatewayType ?? gw.gateway_type ?? '';
                        const gwName = gw.name ?? gw.Name ?? gwType;
                        const isManual = gwType === 'manual';
                        return (
                            <Grid item xs={12} sm={4} key={gwId}>
                                <div onClick={() => this.setState({ selectedPaymentGatewayId: gwId })} style={{
                                    cursor: 'pointer', borderRadius: 12, border: sel ? '2px solid #277afe' : '1px solid #e0e0e0',
                                    backgroundColor: sel ? '#e3f2fd' : '#fff', textAlign: 'center', padding: 20, transition: 'all 0.2s', position: 'relative'
                                }}>
                                    {sel && <CheckCircleIcon style={{ color: '#277afe', fontSize: 20, position: 'absolute', right: 12, top: 12 }} />}
                                    <Typography variant="h6" style={{ fontWeight: 600, color: sel ? '#0d47a1' : '#424242' }}>{gwName}</Typography>
                                    <Chip label={isManual ? 'Faturamento Manual' : 'Gateway Online'} size="small" style={{ marginTop: 8, backgroundColor: isManual ? '#fff3e0' : '#e8f5e9' }} />
                                    {(gw.isdefault || gw.isDefault) && <Chip label="Padrao" size="small" style={{ marginTop: 4, marginLeft: 4, backgroundColor: '#e0e0e0', fontSize: 11 }} />}
                                </div>
                            </Grid>
                        );
                    })}
                    {paymentGateways.length === 0 && <Typography color="textSecondary" style={{ padding: 16 }}>Nenhum metodo de pagamento configurado.</Typography>}
                </Grid>
            </div>
        );
    }

    render() {
        const { classes, headerMenu } = this.props;
        const intl = this.props.intl;
        const { activeStep } = this.state;
        const steps = this.getStepLabels();
        const isLastStep = activeStep === steps.length - 1;

        return (
            <div className={classes.root} style={{ paddingLeft: 0, marginLeft: 0 }}>
                <HeaderMenu />
                <main className={clsx(classes.content, { [classes.contentShift]: headerMenu.open })}>
                    <div className={classes.drawerHeader} />
                    <Container component='main' maxWidth='md'>
                        <CssBaseline />
                        <Grid container spacing={3}><Grid item xs={12}>
                            <SectionCard
                                context="assignment"
                                title={intl.formatMessage({ id: "admin.subscription.create" })}
                                subtitle="Assistente de criação de assinatura — selecione aplicativos, plano e periodicidades"
                            >
                                <Stepper activeStep={activeStep} orientation="vertical">
                                    {steps.map((label, index) => (
                                        <Step key={label}><StepLabel>{label}</StepLabel><StepContent>
                                            <div style={{ marginTop: 16, marginBottom: 16 }}>{this.getStepContent(index)}</div>
                                            <div style={{ marginTop: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                <div>
                                                    <Button variant="contained" color="default" component={Link} to={`/${this.props.match.params.lang}/admin-subscriptions`}>{intl.formatMessage({ id: "cancel" })}</Button>
                                                </div>
                                                <div>
                                                    {activeStep > 0 && <Button onClick={this.handleBack} style={{ marginRight: 8 }}>{intl.formatMessage({ id: "admin.create.back" })}</Button>}
                                                    {!isLastStep && <Button variant="contained" color="primary" onClick={this.handleNext}>{intl.formatMessage({ id: "admin.create.next" })}</Button>}
                                                    {isLastStep && <Button variant="contained" color="primary" onClick={this.handleSubmit}>{intl.formatMessage({ id: "admin.create.confirm" })}</Button>}
                                                </div>
                                            </div>
                                        </StepContent></Step>
                                    ))}
                                </Stepper>
                            </SectionCard>
                        </Grid></Grid>

                        {/* Confirm Dialog */}
                        <Dialog open={this.state.confirmDialogOpen} onClose={() => this.setState({ confirmDialogOpen: false })} maxWidth="sm" fullWidth PaperProps={{ style: { borderRadius: 12, overflow: 'hidden' } }}>
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px 24px', backgroundColor: '#f5f7fa' }}>
                                <Typography variant="h6" style={{ fontWeight: 600, fontSize: 18 }}>{intl.formatMessage({ id: "admin.trial.create.confirm.title" })}</Typography>
                                <IconButton size="small" onClick={() => this.setState({ confirmDialogOpen: false })} style={{ color: '#9e9e9e' }}><CloseIcon fontSize="small" /></IconButton>
                            </div>
                            <Divider />
                            <DialogContent style={{ padding: '16px 24px' }}>
                                <Typography variant="body2" color="textSecondary">{intl.formatMessage({ id: "admin.trial.create.confirm.message" })}</Typography>
                                <Divider style={{ margin: '12px 0' }} />
                                <Typography variant="body2"><strong>{intl.formatMessage({ id: "admin.trial.company.name" })}:</strong> {this.state.item.companyName}</Typography>
                                <Typography variant="body2"><strong>Workspace:</strong> {this.state.item.workspace}</Typography>
                                <Typography variant="body2"><strong>Produtos:</strong> {this.state.selectedProductIds.map(id => this.getProductName(id)).join(', ')}</Typography>
                                <Typography variant="body2"><strong>Total:</strong> R$ {this.getTotal().toFixed(2)}/mes</Typography>
                            </DialogContent>
                            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, padding: '12px 24px 16px', backgroundColor: '#f5f5f5', borderTop: '1px solid #e0e0e0' }}>
                                <Button onClick={() => this.setState({ confirmDialogOpen: false })} style={{ textTransform: 'none', fontWeight: 500 }}>{intl.formatMessage({ id: "cancel" })}</Button>
                                <Button variant="contained" color="primary" onClick={this.handleConfirmCreate} style={{ textTransform: 'none', fontWeight: 600, borderRadius: 6 }}>{intl.formatMessage({ id: "confirm" })}</Button>
                            </div>
                        </Dialog>

                        {this.state.loading && <Overlay><CircularProgress color="secondary" /></Overlay>}
                        <CustomizedSnackbars variant={this.state.notificationVariant} message={this.state.notificationMessage} isOpen={this.state.openNotification} toClose={this.closeNotification} />
                    </Container>
                </main>
                <Footer />
            </div>
        );
    }
}

AdminSubscriptionCreate.propTypes = { classes: PropTypes.object.isRequired };
const mapStateToProps = state => ({ headerMenu: state.headerMenu, userSession: state.userSession });
const mapDispatchToProps = dispatch => bindActionCreators(componentActions, dispatch);
export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(withStyles(Styles)(AdminSubscriptionCreate)));
